import {axios} from "../../core";

export default {
    signUp: postData => axios.post("/user/signup", postData),
    getMe: () => axios.get("/user/me"),
};
